<div class="auth-page">
  <div class="auth-page__header">
    <div class="auth-page__welcome">
      <img src="../../../assets/images/app-icon.svg" class="auth-page__welcome-logo" />
      <div class="auth-page__welcome-title">Welcome to Grid Dynamics</div>
      <div class="auth-page__welcome-hint">Please sign in to your account to start using the applications</div>
    </div>
  </div>
  <div class="auth-page__main">
    <div class="auth-page__fields" *ngIf="loginWithGoogle">
      <div class="auth-page__error-container">
        <div class="auth-page__error" *ngIf="wrongGoogleAccount">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="auth-page__error-icon"
          >
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              class="auth-page__error-icon-content"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
            ></path>
          </svg>
          <span class="auth-page__error-text">Please, use corporate account</span>
        </div>
      </div>

      <div
        class="auth-page__auth-button auth-page__auth-button_google"
        [class.auth-page__auth-button_disabled]="isLoggingIn"
        #googleButtonWrapper
      ></div>

      <div
        class="auth-page__auth-toggle"
        [ngClass]="{ 'auth-page__auth-toggle_progress': isLoggingIn }"
        (click)="toggleAuthMethod()"
      >
        Sign in with login and password
      </div>
    </div>

    <form class="auth-page__fields" *ngIf="!loginWithGoogle" [formGroup]="loginForm">
      <div class="auth-page__error-container">
        <div
          class="auth-page__error"
          *ngIf="
            (loginControl.invalid && loginControl.touched) ||
            (passwordControl.invalid && passwordControl.touched) ||
            notCorrectCredentials
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="auth-page__error-icon"
          >
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              class="auth-page__error-icon-content"
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
            ></path>
          </svg>
          <span class="auth-page__error-text">
            {{ notCorrectCredentials ? messages.errorAuth : messages.validations }}
          </span>
        </div>
      </div>

      <div class="auth-page__inputs">
        <div class="auth-page__input">
          <input
            type="text"
            class="auth-page__input-field auth-page__input-field_username"
            placeholder="LDAP Name"
            id="login"
            autocomplete="on"
            [formControl]="loginControl"
            (focus)="loginFocusHandler()"
            (blur)="loginBlurHandler()"
            (keydown.enter)="loginForm.valid && signIn()"
          />
          <i
            *ngIf="showHint"
            class="auth-page__input-ldap-hint material-icons"
            [popper]="ldapHint"
            [popperDelay]="100"
            [popperTrigger]="'hover'"
            [popperPlacement]="'right'"
            [popperStyles]="tooltipStyles"
          >
            info_outline
          </i>
          <popper-content #ldapHint>e.g. dtrump</popper-content>
          <div class="auth-page__input-underline auth-page__input-underline_username">
            <div class="auth-page__input-underline-block auth-page__input-underline-block_username"></div>
          </div>
        </div>

        <div class="auth-page__visibility-toggle" (click)="toggleInputType()" *ngIf="isPasswordVisible">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              class="auth-page__visibility-toggle-content"
              d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
            ></path>
          </svg>
        </div>

        <div class="auth-page__visibility-toggle" (click)="toggleInputType()" *ngIf="!isPasswordVisible">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none"></path>
            <path
              class="auth-page__visibility-toggle-content"
              d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
            ></path>
          </svg>
        </div>

        <div class="auth-page__input">
          <input
            autocomplete="on"
            [type]="inputType"
            class="auth-page__input-field auth-page__input-field_password"
            placeholder="Password"
            id="password"
            [formControl]="passwordControl"
            (keydown.enter)="loginForm.valid && signIn()"
          />
          <div class="auth-page__input-underline auth-page__input-underline_password">
            <div class="auth-page__input-underline-block auth-page__input-underline-block_password"></div>
          </div>
        </div>
      </div>

      <div class="auth-page__caps-attentions" [ngClass]="{ 'auth-page_visible-hidden': !capsLock }">
        <span>CAPS is on</span>
      </div>
      <div class="auth-page__auth-button">
        <app-ingrid-button
          [disabled]="loginForm.invalid"
          (clicked)="signIn()"
          id="ldap-login-button"
          [progress]="isLoggingIn"
        >
          Sign in now
        </app-ingrid-button>
      </div>
      <div
        class="auth-page__auth-toggle"
        [ngClass]="{ 'auth-page__auth-toggle_progress': isLoggingIn }"
        (click)="toggleAuthMethod()"
      >
        Sign in with Google
      </div>
    </form>

    <div class="auth-page__fields auth-page__fields_dev" *ngIf="!isProduction">
      <div class="auth-page__fields-header">NOAUTH</div>
      <div class="auth-page__inputs">
        <div class="auth-page__input">
          <input
            type="text"
            class="auth-page__input-field"
            autocomplete="on"
            id="noauth-login-input"
            (focus)="noauthFocusHandler()"
            (blur)="noauthBlurHandler()"
            [formControl]="noauthControl"
            (keydown.enter)="noauthControl.value.trim() && signInNoauth()"
          />
          <div class="auth-page__input-underline">
            <div class="auth-page__input-underline-block"></div>
          </div>
        </div>
      </div>

      <div class="auth-page__noauth-button">
        <app-ingrid-button
          id="noauth-login-button"
          [progress]="isLoggingIn"
          [disabled]="isNoAuthButtonDisabled"
          (clicked)="signInNoauth()"
        >
          Sign in (noauth)
        </app-ingrid-button>
      </div>
    </div>
  </div>
  <div class="auth-page__footer">
    <app-footer></app-footer>
  </div>
</div>
